import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faEnvelope, faUnlockAlt, faUser, faUserTag, faCalendarAlt, faVenusMars, faPhone } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faGithub, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { Col, Row, Form, Card, Button, FormCheck, Container, InputGroup, Spinner } from '@themesberg/react-bootstrap';
import { useNavigate, Link } from "react-router-dom";
import { BASE_URL } from "../../constants";
const Signup = () => {
  const [step, setStep] = useState(1); 
  const [basicInfo, setBasicInfo] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [roleSpecificInfo, setRoleSpecificInfo] = useState({
    dateOfBirth: "",
    gender: "",
    phone: "",
    role: "", 
  });
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  
  const handleBasicInfoChange = (e) => {
    const { name, value } = e.target;
    setBasicInfo({ ...basicInfo, [name]: value });
  };

  
  const handleRoleSpecificChange = (e) => {
    const { name, value } = e.target;
    setRoleSpecificInfo({ ...roleSpecificInfo, [name]: value });
  };

  
  const handleSubmitBasicInfo = (e) => {
    e.preventDefault();
    if (basicInfo.password !== basicInfo.confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    setError(null);
    setStep(2);
  };

  
  const convertRoleToFlags = (role) => {
    switch (role) {
      case "admin":
        return { isAdmin: true, isRefugee: false, isVolunteer: false, isState: false };
      case "refugee":
        return { isAdmin: false, isRefugee: true, isVolunteer: false, isState: false };
      case "volunteer":
        return { isAdmin: false, isRefugee: false, isVolunteer: true, isState: false };
      case "state":
        return { isAdmin: false, isRefugee: false, isVolunteer: false, isState: true };
      default:
        return { isAdmin: false, isRefugee: false, isVolunteer: false, isState: false };
    }
  };

 
  const handleFinalSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const roleFlags = convertRoleToFlags(roleSpecificInfo.role); 
    
    try {
      const response = await fetch(`${BASE_URL}/users/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ...basicInfo,
          ...roleSpecificInfo,
          ...roleFlags, 
        }),
      });
      const data = await response.json();
      setLoading(false);
  
      if (!response.ok) {
        setError(data.message || "Something went wrong");
        return;
      }
  
      alert("Registration successful! Please check your email to verify your account.");
      navigate("/signin");
    } catch (err) {
      setLoading(false);
      setError("Server Error");
    }
  };

  return (
    <main>
        <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5" >
            <Container>
            <p className="text-center">
                <Card.Link as={Link} to="/" className="text-gray-700">
                  <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Back to homepage
                </Card.Link>
              </p>

              <div className="d-flex justify-content-center align-items-center">
              
      {step === 1 && (
        <div className="p-4 shadow bg-white rounded">
          <>
              <h3 className="text-center">Create an account</h3>
        <Form  className="mt-4" onSubmit={handleSubmitBasicInfo}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Your First Name</Form.Label>
                <InputGroup>
                <InputGroup.Text>
                        <FontAwesomeIcon icon={faUser} />
                      </InputGroup.Text>
                <Form.Control
                  type="text"
                  name="firstName"
                  value={basicInfo.firstName}
                  onChange={handleBasicInfoChange}
                  placeholder="Enter your first name"
                  required
                />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Your Last Name</Form.Label>
                <InputGroup>
                <InputGroup.Text>
                        <FontAwesomeIcon icon={faUser} />
                      </InputGroup.Text>
                <Form.Control
                  type="text"
                  name="lastName"
                  value={basicInfo.lastName}
                  onChange={handleBasicInfoChange}
                  placeholder="Enter your last name"
                  required
                />
                </InputGroup>
                </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Your Email</Form.Label>
                <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                <Form.Control
                  type="email"
                  name="email"
                  value={basicInfo.email}
                  onChange={handleBasicInfoChange}
                  placeholder="Enter your email"
                  required
                />
                 </InputGroup>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Your Password</Form.Label>
                <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                <Form.Control
                  type="password"
                  name="password"
                  value={basicInfo.password}
                  onChange={handleBasicInfoChange}
                  placeholder="Create a password"
                  required
                />
              </InputGroup>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Confirm Your Password</Form.Label>
                <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faUnlockAlt} />
                      </InputGroup.Text>
                <Form.Control
                  type="password"
                  name="confirmPassword"
                  value={basicInfo.confirmPassword}
                  onChange={handleBasicInfoChange}
                  placeholder="Confirm your password"
                  required
                />
              </InputGroup>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Your Role</Form.Label>
                <InputGroup>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faUserTag} />
              </InputGroup.Text>
                <Form.Select
                  name="role"
                  value={roleSpecificInfo.role}
                  onChange={handleRoleSpecificChange}
                  required
                >
                  <option value="">Select Role</option>
                  <option value="refugee">Refugee</option>
                  <option value="volunteer">Volunteer</option>
                  
                </Form.Select>
                </InputGroup>
                </Form.Group>
            </Col>
          </Row>
          <Button type="submit" className="w-100 mt-3" disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "Continue"}
        </Button>
          {error && <p className="text-danger mt-3">{error}</p>}
        </Form>
     
         <div className="d-flex justify-content-center align-items-center mt-4">
         <span className="fw-normal">
         You have an account?
           <Card.Link as={Link} to='/signin' className="fw-bold">
             {` Sign In `}
           </Card.Link>
         </span>
       </div>
       </>
        </div>
      )}
  
  {step === 2 && (
       <div className="bg-white border-light p-4 p-lg-5 w-100 fmxw-500 mt-4">
        <h3 className="text-center mb-4">Complete Your Profile</h3>
  <Form  onSubmit={handleFinalSubmit}>
  <Row>
        <Col md={6}>
    {/* Date of Birth */}
    <Form.Group className="mb-3">
      <Form.Label>Date of Birth</Form.Label>
      <InputGroup>
        <InputGroup.Text>
          <FontAwesomeIcon icon={faCalendarAlt} />
        </InputGroup.Text>
        <Form.Control
          type="date"
          name="dateOfBirth"
          value={roleSpecificInfo.dateOfBirth}
          onChange={handleRoleSpecificChange}
          placeholder="Enter your date of birth"
          required
        />
      </InputGroup>
    </Form.Group>
    </Col>
    {/* Gender */}
    <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Gender</Form.Label>
      <InputGroup>
        <InputGroup.Text>
          <FontAwesomeIcon icon={faVenusMars} />
        </InputGroup.Text>
        <Form.Select
          name="gender"
          value={roleSpecificInfo.gender}
          onChange={handleRoleSpecificChange}
          required
        >
          <option value="">Select Gender</option>
          <option value="Female">Female</option>
          <option value="Male">Male</option>
        </Form.Select>
      </InputGroup>
    </Form.Group>
    </Col>
    {/* Phone */}
    <Col md={6}>
    <Form.Group className="mb-3">
      <Form.Label>Phone</Form.Label>
      <InputGroup>
        <InputGroup.Text>
          <FontAwesomeIcon icon={faPhone} />
        </InputGroup.Text>
        <Form.Control
          type="text"
          name="phone"
          value={roleSpecificInfo.phone}
          onChange={handleRoleSpecificChange}
          placeholder="Enter your phone number"
          required
        />
      </InputGroup>
    </Form.Group>
    </Col>
    </Row>
    {/* Submit Button */}
    <Button type="submit" className="w-100 mt-3" disabled={loading}>
      {loading ? <Spinner animation="border" size="sm" /> : 'Submit'}
    </Button>
    
    {/* Error Message */}
    {error && <p className="text-danger mt-3">{error}</p>}
  </Form>
  <div className="d-flex justify-content-center align-items-center mt-4">
                              <span className="fw-normal">
                              You have an account?
                                <Card.Link as={Link} to='/signin' className="fw-bold">
                                  {` Sign In `}
                                </Card.Link>
                              </span>
                            </div>
  </div>
)}

          
                            </div>
                           
     </Container>
            </section>  
            </main>
  
  );
};

export default Signup;
